import { gsap } from 'gsap'
import { onMount, onDestroy } from '@/modules/_'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const overlay = element.querySelector(
    '.change_design_cta_overlay'
  ) as HTMLElement
  const image = element.querySelector('img') as HTMLImageElement

  if (!overlay || !image) return

  let tlIn: gsap.core.Timeline | null = null
  let tlOut: gsap.core.Timeline | null = null

  const easeOutQuart = 'cubic-bezier(0.165, 0.84, 0.44, 1)'
  const easeInOutQuart = 'cubic-bezier(0.76, 0, 0.24, 1)'
  const easeInOutCubic = 'cubic-bezier(0.65, 0, 0.35, 1)'

  const createHoverInTimeline = () => {
    return gsap
      .timeline({ paused: true })
      .to(
        overlay,
        {
          backgroundColor: '#11111240',
          backdropFilter: 'blur(3px)',
          duration: 0.7,
          ease: easeOutQuart,
        },
        0
      )
      .to(
        image,
        {
          scale: 1.05,
          duration: 0.7,
          ease: easeOutQuart,
        },
        0
      )
  }

  const createHoverOutTimeline = () => {
    return gsap
      .timeline({ paused: true })
      .to(
        overlay,
        {
          backgroundColor: 'transparent',
          backdropFilter: 'blur(0px)',
          duration: 0.6,
          ease: easeOutQuart,
        },
        0
      )
      .to(
        image,
        {
          scale: 1,
          duration: 0.6,
          ease: easeOutQuart,
        },
        0
      )
  }

  const handleMouseEnter = () => {
    if (tlOut) tlOut.kill()
    if (!tlIn) tlIn = createHoverInTimeline()
    tlIn.restart()
  }

  const handleMouseLeave = () => {
    if (tlIn) tlIn.kill()
    if (!tlOut) tlOut = createHoverOutTimeline()
    tlOut.restart()
  }

  onMount(() => {
    gsap.set(overlay, {
      backgroundColor: 'transparent',
      backdropFilter: 'blur(0px)',
    })

    gsap.set(image, {
      scale: 1,
    })

    // Create GSAP matchMedia instance
    const mm = gsap.matchMedia()

    // Only enable hover on devices with hover capability and fine pointer (mouse/trackpad)
    mm.add('(hover: hover) and (pointer: fine)', () => {
      element.addEventListener('mouseenter', handleMouseEnter)
      element.addEventListener('mouseleave', handleMouseLeave)

      // Cleanup function when media query stops matching
      return () => {
        element.removeEventListener('mouseenter', handleMouseEnter)
        element.removeEventListener('mouseleave', handleMouseLeave)
      }
    })
  })

  onDestroy(() => {
    element.removeEventListener('mouseenter', handleMouseEnter)
    element.removeEventListener('mouseleave', handleMouseLeave)
    tlIn?.kill()
    tlOut?.kill()
  })
}
